import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5dd4ca12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "download" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Partition List", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Payload SHA256 Hash", -1))
const _hoisted_6 = { style: {"text-align":"center","display":"block"} }
const _hoisted_7 = {
  key: 2,
  class: "signature"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Metadata Signature", -1))
const _hoisted_9 = { style: {"white-space":"pre-wrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_BasicInfo = _resolveComponent("BasicInfo")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_PartitionDetail = _resolveComponent("PartitionDetail")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.zipFile && _ctx.payload)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "download-btn",
          onClick: _ctx.exportOTAPackage
        }, {
          default: _withCtx(() => [
            _createTextVNode("Export Metadata")
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("a", _hoisted_1, null, 512),
    _createVNode(_component_BasicInfo, {
      zipFile: _ctx.zipFile,
      payload: _ctx.payload,
      class: "mb-5"
    }, null, 8, ["zipFile", "payload"]),
    _createVNode(_component_v_divider),
    (_ctx.payload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.payload.manifest)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "mb-5"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payload.manifest.partitions, (partition) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: partition.partitionName,
                      cols: "12",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          elevation: "5",
                          hover: "",
                          shaped: "",
                          class: "partial-info"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_PartitionDetail, {
                              partition: partition,
                              dynamicPartitionList: _ctx.dynamicPartitions
                            }, null, 8, ["partition", "dynamicPartitionList"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider),
          (!_ctx.payload.manifest.nonAB && _ctx.payloadHash)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.payloadHash), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider),
          (_ctx.payload.metadata_signature && !_ctx.payload.manifest.nonAB)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.octToHex(_ctx.payload.metadata_signature.signatures[0].data)), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}